/**
 * Note validation schemas using Zod
 */

import { z } from 'zod';

const AttachmentSchema = z.object({
  id: z.string(),
  fileName: z.string(),
  fileType: z.enum(['document', 'image', 'video']),
  mimeType: z.string(),
  size: z.number(),
  blobPath: z.string(),
  thumbnailPath: z.string().optional(),
  uploadedAt: z.string(),
});

export const CreateNoteSchema = z
  .object({
    dealId: z.string().min(1, 'Deal ID is required'),
    note: z.string().max(5000, 'Note must be at most 5000 characters').optional(),
    noteType: z
      .enum(['general', 'call', 'email', 'meeting', 'internal', 'deliverable_update', 'attachment'])
      .default('general'),
    isEncrypted: z.boolean().optional(),
    attachmentIds: z.array(z.string()).optional(),
    attachments: z.array(AttachmentSchema).optional(),
    metadata: z
      .object({
        sentiment: z.enum(['positive', 'neutral', 'negative']).optional(),
        tags: z.array(z.string()).optional(),
        relatedDeliverableId: z.string().optional(),
      })
      .optional(),
  })
  .refine(
    (data) =>
      data.note?.trim() ||
      (data.attachmentIds && data.attachmentIds.length > 0) ||
      (data.attachments && data.attachments.length > 0),
    {
      message: 'Note is required',
      path: ['note'],
    }
  );

export const UpdateNoteSchema = z.object({
  note: z
    .string()
    .min(1, 'Note is required')
    .max(5000, 'Note must be at most 5000 characters')
    .optional(),
  noteType: z
    .enum(['general', 'call', 'email', 'meeting', 'internal', 'deliverable_update', 'attachment'])
    .optional(),
  isEncrypted: z.boolean().optional(),
  attachments: z.array(AttachmentSchema).optional(),
  metadata: z
    .object({
      sentiment: z.enum(['positive', 'neutral', 'negative']).optional(),
      tags: z.array(z.string()).optional(),
      relatedDeliverableId: z.string().optional(),
    })
    .optional(),
});
